export class RoleParent {
  constructor() {
    this.list = []
  }

  addRole(item) {
    this.list.push(Role.buildFromAPI(item))
  }

  updateRole(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, Role.buildFromAPI(item))
  }

  removeRole(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => Role.buildFromAPI(el))
    }
    return this
  }
}

export class Role {
  constructor() {
    this.id = null
    this.name = null
  }

  getForAPI() {
    return {
      id: this.id,
      name: this.name,
    }
  }

  static buildFromAPI(obj) {
    const _this = new Role()
    if (obj) {
      _this.id = obj.id
      _this.name = obj.name
    }
    return _this
  }
}